module.exports = __webpack_public_path__ + "static/media/Rectangle 31.cc739102.svg";